import { render } from "./HeroiconsOutlineDotsCircleHorizontal.vue?vue&type=template&id=c890dffc"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsCircleHorizontal.vue"]])

export default __exports__